import * as React from 'preact/compat'
import cn from 'classnames'
import SVG from '../SVG'
import AutosuggestWrapper from '../autocomplete/Autocomplete'
import buttonsCss from '../../../css/buttons.pcss.json'
import formCss from '../../../css/form.pcss.json'

interface PropTypes {
  companies: Array<{
    id: number,
    name: string
  }>
  type: string,
  name: string
}

interface StateTypes {
  companies: Array<{
    id: number,
    name: string
  }>,
  hasError: boolean
}

export default class GameCompaniesEditor extends React.Component<PropTypes, StateTypes> {

  state: StateTypes = {
    companies: this.props.companies,
    hasError: false
  }

  componentDidUpdate(previousProps: Readonly<PropTypes>, _previousState: Readonly<StateTypes>, _snapshot: any) {
    if (previousProps.companies !== this.props.companies) {
      this.setState({
        companies: this.props.companies
      })
    }
  }

  removeCompany = (id: number) => {
    this.setState({
      companies: this.state.companies.filter(c => c.id !== id)
    })
  }

  addCompany = ({ value: id, label: name }: { value: string, label: string }) => {
    this.setState({
      companies: [...this.state.companies, { id: parseInt(id), name }]
    })
  }

  render() {
    const { companies, hasError } = this.state

    return <>
      <div style='display: flex; align-items: center; column-gap: 24px; margin-bottom: 16px'>
        {companies.map(company => {
          return <div key={company.id} style='display: flex; align-items: center;'>
            <input type='hidden' name={`${this.props.name}[${company.id}][]`} value={this.props.type}/>
            {company.name}
            <button
              type='button'
              className={cn(buttonsCss['icon'], buttonsCss['icon--low-contrast'])}
              onClick={() => this.removeCompany(company.id)}
              style='--icon-size: 32px;'
            >
              <SVG i='sg-new/cross' adaptive/>
            </button>
          </div>
        })}
      </div>
      <AutosuggestWrapper
        url='companies/autocomplete'
        name=''
        onChange={this.addCompany}
        clearOnSelect
        className={formCss['input']}
        placeholder='Начни вводить название'
      />
      <span
        className={cn({
          [`${formCss['hint']}`]: !hasError,
          [`${formCss['error-hint']}`]: hasError
        })}
      >Выбери вариант из выпадающего списка</span>
    </>
  }
}
